<template>
    <div 
        class="o-player player"
        @click="handleClick"
    >
        <!--Should be slider or iframe in future-->
        <img
            :src="screensaverUrl"
            class="player-img"
            :alt="$t('o-player-screensaver')"
            v-if="screensaverUrl"
        >
        <span
            class="player-text-wrapper"
            v-else
        >
            <span class="player__text" v-html="$t('o-player-text')" />
            <svg-icon
                original
                name="player/terminal"
                class="player__icon"
            />
        </span>
    </div>
</template>

<script>

import {mapGetters} from 'vuex'

export default {
    name: "OPlayer",
    data: () =>({
        screensaverUrl: null
    }),
    methods: {
        handleClick() {
            this.$emit('onPlayerClick', true);
        }
    },
    computed:{
        ...mapGetters([
            't',
            'getMap',
            'getTerminal'
        ])
    },
    created() {
        this.screensaverUrl = this.t(this.getTerminal, 'screensaver_url') || this.t(this.getMap, 'screensaver_url') || ''
    }
}
</script>

<style lang="scss">
@import "o-player";   
</style>